export default "__VITE_ASSET__gmfuwOgC__"